import { render, staticRenderFns } from "./internet.vue?vue&type=template&id=8fc23258&scoped=true"
import script from "./internet.vue?vue&type=script&lang=js"
export * from "./internet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc23258",
  null
  
)

export default component.exports